module.exports = __webpack_public_path__ + "cement/img/组 536@2x.5cf5bdc1.png";